export const ATRIBUTO_DEL_PANEL = 'data-softphone-panel';

export const esDelPanelDeLlamada = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(`[${ATRIBUTO_DEL_PANEL}]`) !== null;

interface EventoDeAfuera {
  target: EventTarget | null;
  preventDefault: () => void;
}

export const ignorandoElPanel =
  <E extends EventoDeAfuera>(propio?: (evento: E) => void) =>
  (evento: E): void => {
    if (esDelPanelDeLlamada(evento.target)) {
      evento.preventDefault();
      return;
    }
    propio?.(evento);
  };
